import { UserRole } from '@/features/users/types/user'
import {
  Building2,
  History,
  KeyRound,
  LayoutDashboard,
  LocateFixed,
  MapPin,
  Monitor,
  Settings,
  Store,
  Truck,
  User,
  Users,
  Wrench,
} from 'lucide-react'
import { ADMIN_ROLES, REPAIR_ROLES, STAFF_ROLES } from './permission'

export type NavItem = {
  titleKey: string
  href: string
  icon?: any
  group: 'main' | 'workflow' | 'account' | 'admin'
  roles?: UserRole[]
}

export const NAV_ITEMS: NavItem[] = [
  // MAIN
  { titleKey: 'navigation.dashboard', href: '/', icon: LayoutDashboard, group: 'main' },
  { titleKey: 'navigation.equipment', href: '/equipment', icon: Monitor, group: 'main', roles: STAFF_ROLES },
  { titleKey: 'navigation.department', href: '/departments', icon: Building2, group: 'main', roles: STAFF_ROLES },
  { titleKey: 'navigation.floormap', href: '/floormaps', icon: MapPin, group: 'main', roles: STAFF_ROLES },
  { titleKey: 'navigation.patient', href: '/patients', icon: User, group: 'main', roles: STAFF_ROLES },

  // WORKFLOW
  { titleKey: 'navigation.request', href: '/requests', icon: Truck, group: 'workflow', roles: STAFF_ROLES },
  {
    titleKey: 'navigation.request-history',
    href: '/requests-history',
    icon: History,
    group: 'workflow',
    roles: STAFF_ROLES,
  },
  { titleKey: 'navigation.repair', href: '/repairs', icon: Wrench, group: 'workflow', roles: REPAIR_ROLES },

  // ACCOUNT
  {
    titleKey: 'navigation.change-password',
    href: '/change-password',
    icon: KeyRound,
    group: 'account',
  },

  // ADMIN
  { titleKey: 'navigation.setting', href: '/settings', icon: Settings, group: 'admin', roles: ADMIN_ROLES },
  { titleKey: 'navigation.user', href: '/users', icon: Users, group: 'admin', roles: ADMIN_ROLES },
  { titleKey: 'navigation.vendor', href: '/vendors', icon: Store, group: 'admin', roles: ADMIN_ROLES },
  {
    titleKey: 'navigation.track-location',
    href: '/track-locations',
    icon: LocateFixed,
    group: 'admin',
    roles: ADMIN_ROLES,
  },
]
